import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-filials",
  "use": "foquz-icon-question-filials-usage",
  "viewBox": "0 0 23 20",
  "content": "<symbol viewBox=\"0 0 23 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-question-filials\"><path d=\"M4 1V0a1 1 0 00-1 1h1zm15 0h1a1 1 0 00-1-1v1zm0 18v1h1v-1h-1zM4 19H3v1h1v-1zm-3-1a1 1 0 100 2v-2zm21 2a1 1 0 100-2v2zM4 2h15V0H4v2zm14-1v18h2V1h-2zm1 17H4v2h15v-2zM5 19V1H3v18h2zm-4 1h21v-2H1v2zm7-9v4h2v-4H8zm5 0v4h2v-4h-2zM8 5v4h2V5H8zm5 0v4h2V5h-2z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol